import { ContentChildren, Directive, Input, QueryList } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FilterDelegate } from '../domain/types';
import { TableColumnHeaderOptionDirective } from './table-column-header-option.directive';

@Directive({
  selector: '[psUiTableColumnFilter]',
})
export class TableColumnFilterDirective {
  @Input()
  public delegate?: FilterDelegate<Record<string, unknown>>;

  @Input()
  public set show(status: boolean) {
    this.showCommand.next(status);
  }

  @ContentChildren(TableColumnHeaderOptionDirective)
  public options: QueryList<TableColumnHeaderOptionDirective> = new QueryList();

  public get show$() {
    return this.showCommand.asObservable();
  }

  private readonly showCommand = new BehaviorSubject<boolean>(true);
}
